/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import FieldSchemesAppQuery, {
	type FieldSchemesAppQuery as FieldSchemesAppQueryType,
} from './__generated__/FieldSchemesAppQuery.graphql';

type GlobalAdminFieldSchemesEntryPointComponent = EntryPointComponent<
	{
		pageQueryRef: FieldSchemesAppQueryType;
	},
	{},
	{},
	{}
>;

export const globalAdminFieldSchemesEntryPoint: EntryPoint<
	GlobalAdminFieldSchemesEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<GlobalAdminFieldSchemesEntryPointComponent>(
		/* webpackChunkName: "async-jira-admin-pages-field-schemes" */ './FieldSchemesApp.tsx',
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => ({
		queries: {
			pageQueryRef: {
				parameters: FieldSchemesAppQuery,
				variables: {
					cloudId: tenantContext.cloudId,
				},
				options: {
					fetchPolicy: 'network-only' as const,
				},
			},
		},
	}),
});
